<div class="form-wrapper">
  <div class="form-popup">
    <right-panel-header [headerTitle]="'Clone Taxonomy'" [buttonText]="'Create Clone'"
      [disabled]="!isFormValid() || isLoading()" [showDeleteButton]="false" (onApply)="onConfirm($event)"
      (onClose)="onCancel($event)">
    </right-panel-header>

    <div class="form-body">
      <div class="form-section-container">
        <!-- New Name Field -->
        <div class="field-container">
          <label for="newName">New Name for Cloned Taxonomy <span class="required-star">*</span></label>
          <input type="text" id="newName" class="custom-input" placeholder="Enter taxonomy name" maxlength="100"
            [value]="newTaxonomyName()" (input)="onNameChange(nameInput.value)" #nameInput>
          <div *ngIf="newTaxonomyName().trim().length > 0 && !isNameUnique()" class="validation-error">
            This taxonomy name already exists. Please choose a unique name.
          </div>
        </div>

        <!-- Version Selection Field -->
        <div class="field-container">
          <label for="version">Version <span class="required-star">*</span></label>
          <taxonomy-version-dropdown [contentList]="versionOptions" [selectedValue]="selectedDropdownOption()"
            [listHeader]="'Select'" [dropDownWidth]="'100%'" [isLoading]="isLoading()"
            (onItemSelect)="onVersionSelect($event)">
          </taxonomy-version-dropdown>
        </div>

        <!-- Description Field -->
        <div class="field-container">
          <label for="description">Taxonomy Description</label>
          <textarea id="description" class="custom-input-description" rows="3"
            placeholder="Enter description (Optional)" #descriptionInput [value]="taxonomyDescription()"
            (input)="onDescriptionChange(descriptionInput.value)">
              </textarea>
        </div>
      </div>
    </div>
  </div>
</div>
